<template>
  <div class="center-warp">
    <div class="inner">
      <div class="top-search">
        <Input :placeholder="'搜索耗材名称、耗材编号'" v-model="queryParams.keyWords" @enter="handleQuery"/>
        <div class="iconfont icon-sousuo" @click="handleQuery"></div>
      </div>
      <div class="billList">
        <div class="top-nav swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide top-nav-item" :class="queryParams.category_id == 0 ? 'on' : ''" @click="navChange(0)" key="0">全部</div>
            <div class="swiper-slide top-nav-item" :class="queryParams.category_id == item.id ? 'on' : ''" @click="navChange(item.id)" v-for="item in categories" :key="item.id">{{item.name}}</div>
          </div>
        </div>
        <div class="goods-warp" v-loading="loading">
          <div class="consumables-item hover-shadow d-flex" v-for="row in list" :key="row.id" @click="handleDetail(row)">
            <img class="consumables-img" :src="row.main_pic" alt="">
            <div>
              <div class="consumables-info1">{{row.name}}</div>
              <div class="consumables-info2">分类：{{row.category_name}};{{row.type == 1 ? '定制耗材' : '标准耗材'}}</div>
              <div class="consumables-info2">耗材编号：{{row.code}}</div>
              <div class="consumables-info2 limit-4">{{row.desc}}</div>
            </div>
          </div>
          <Empty v-if="!list.length" :info="'暂无耗材'" :img-width="'200px'" />
        </div>

        <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />
      </div>
    </div>
  </div>
</template>

<script>
import { search, getCategoryList } from "@/http/product";
import Pagination from "@/components/Pagination";
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.min.css'

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      navIndex: 0,
      categories: [],
      list: [],
      total: 0,
      last_page: 0,
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 10,
        category_id: 0,
        keyWords: undefined,
      },
    };
  },
  created() {
    this.getCategory();
    this.getList();

  },
  methods: {
    initBanner(){
      new Swiper('.top-nav',{
        freeMode: true,
        slidesPerView:'auto'
      })
    },
    navChange(i) {
      this.navIndex = i;
      this.queryParams.category_id = i;
      this.handleQuery();
    },
    getList() {
      this.loading = true;
      search(this.queryParams).then((res) => {
        this.list = res.data.data;
        this.total = res.data.total;
        this.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    getCategory() {
      let _that = this
      getCategoryList().then((res) => {
        this.categories = res.data;
        this.$nextTick(()=>{
          _that.initBanner()
        })
      });
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleDetail(row) {
      this.$router.push({ path: "/consumables/detail/" + row.id + "" });
    },
  },
};
</script>

<style scoped src="../../assets/css/consumables.css">
</style>
